import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { StyledCardContent } from './card-content.style.js';

const CardContent = props => {
    const { className = '', children } = props, rest = __rest(props, ["className", "children"]);
    return (jsx(StyledCardContent, Object.assign({ className: className }, rest, { children: children }), void 0));
};

export { CardContent as default };
